import React from 'react';
import { Badge } from './badge';
import { CheckCircle, Clock, XCircle, CreditCard, AlertCircle } from 'lucide-react';

const STATUS_CONFIG = {
  pending_finance: {
    label: 'Awaiting Finance',
    className: 'bg-amber-500/15 text-amber-500 border-amber-500/30',
    icon: Clock,
  },
  pending_founder: {
    label: 'Awaiting Founder',
    className: 'bg-blue-500/15 text-blue-500 border-blue-500/30',
    icon: AlertCircle,
  },
  approved: {
    label: 'Approved',
    className: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/30',
    icon: CheckCircle,
  },
  paid: {
    label: 'Paid',
    className: 'bg-green-500/15 text-green-500 border-green-500/30',
    icon: CreditCard,
  },
  rejected: {
    label: 'Rejected',
    className: 'bg-red-500/15 text-red-500 border-red-500/30',
    icon: XCircle,
  },
  rejected_finance: {
    label: 'Rejected by Finance',
    className: 'bg-red-500/15 text-red-500 border-red-500/30',
    icon: XCircle,
  },
  rejected_founder: {
    label: 'Rejected by Founder',
    className: 'bg-red-500/15 text-red-500 border-red-500/30',
    icon: XCircle,
  },
};

const formatFallback = (status) =>
  String(status || 'unknown')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

const StatusBadge = ({ status, className = '' }) => {
  const config = STATUS_CONFIG[status] || {
    label: formatFallback(status),
    className: 'bg-muted text-muted-foreground border-border',
    icon: Clock,
  };

  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${config.className} ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {config.label}
    </Badge>
  );
};

export default StatusBadge;
